import Appbar from '@asphalt-react/appbar';
import Button from '@asphalt-react/button';
import { ArrowRight } from '@asphalt-react/iconpack';
import Logo, { Coffer } from '@asphalt-react/logo';
import React from 'react';
import { useHistory } from 'react-router-dom';
import coffer_screenshot from '../../assets/coffer_screenshot.png';
import routes from '../models/route-constants';
import styles from './LandingPage.module.css';
import ic_asana from '../../assets/ic_asana.svg';
import ic_slack from '../../assets/ic_slack.svg';

function LandingPage() {
    let history = useHistory();
    return (
        <div className={styles.landingPageContainer}>
            <Appbar
                logo={<Logo product='Coffer' symbol={<Coffer />} />}
                footer={
                    <div className={styles.loginBtnContainer}>
                        <Button
                            nude
                            onClick={() => {
                                history.push(`/${routes.LOGIN}`);
                            }}>
                            Login
                        </Button>
                    </div>
                }
            />
            <div className={styles.contentContainer}>
                <div className={styles.aboutSection}>
                    <h1 className={styles.tagline}>
                        A home for Gojek Illustrations
                    </h1>

                    <p className={styles.description}>
                        Coffer is an asset handoff and management app. It helps
                        designers create, edit and manage assets painlessly.
                    </p>

                    <div className={styles.startButtonContainer}>
                        <Button
                            size='l'
                            qualifier={<ArrowRight />}
                            stretch
                            onClick={() => {
                                history.push(`/${routes.LOGIN}`);
                            }}
                            qualifierEnd={true}>
                            Login to Coffer
                        </Button>
                    </div>
                </div>

                <div className={styles.imageContainer}>
                    <img
                        src={coffer_screenshot}
                        className={`${styles.image} shadowHigh`}
                        alt='coffer dashboard homepage'
                    />
                </div>

                <div className={styles.contactUsContainer}>
                    <p className={styles.heading3XL}>Contact us</p>
                    <p className={styles.bodyM}>
                        For any queries, help or complaints please reach out to
                        us.
                    </p>
                    <div className={styles.contactUsMediumsRow}>
                        <a
                            href='https://form.asana.com?hash=a463c2a7dae0b8d0e7c99c94de982a4d1ae558fdb7ba1995013cb18abcdeddd4&id=1190800018891569'
                            target='_blank'
                            rel='noopener noreferrer'>
                            <img src={ic_asana} alt='asana' />
                        </a>
                        <a
                            href='https://gojek.slack.com/archives/C019JG25AJW'
                            target='_blank'
                            rel='noopener noreferrer'>
                            <img src={ic_slack} alt='slack' />
                        </a>
                    </div>
                </div>

                <div className={styles.footer}>
                    <div className={styles.footerContent}>
                        <p className={styles.bodyM}>
                            Made with{' '}
                            <span role='img' aria-label='heart'>
                                ❤️
                            </span>{' '}
                            by{' '}
                            <a
                                href='https://asphalt.pages.golabs.io/'
                                target='_blank'
                                rel='noopener noreferrer'>
                                UXE
                            </a>{' '}
                            &{' '}
                            <a
                                href='https://go-jek.atlassian.net/wiki/spaces/WEBX/overview'
                                target='_blank'
                                rel='noopener noreferrer'>
                                WebX
                            </a>
                        </p>
                        <p className={styles.bodyM}>
                            Powered by{' '}
                            <a
                                href='https://asphalt.pages.golabs.io/asphalt-react/'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Asphalt React
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LandingPage;
